export default __webpack_public_path__ + "static/media/life03.94646b29.png";